import { cn } from "@/shared/utils/index";
import { Button } from "@/shared/components/ui/button";

interface ActionBarProps {
  selectedCount: number;
  totalCount: number;
  displayedCount: number;
  onSetMarkup?: () => void;
  onResetSelection?: () => void;
  className?: string;
}

export function ActionBar({
  selectedCount,
  totalCount,
  displayedCount,
  onSetMarkup,
  onResetSelection,
  className,
}: ActionBarProps) {
  return (
    <div className={cn("flex items-center justify-between mb-4", className)}>
      <div className="flex items-center gap-3">
        <Button onClick={onSetMarkup} disabled={selectedCount === 0} className="bg-[#003399] hover:bg-blue-800">
          Установить наценку
        </Button>
        <Button variant="outline" onClick={onResetSelection}>
          Сбросить выбор
        </Button>
        {selectedCount > 0 && (
          <span className="text-sm text-muted-foreground">
            Выбрано рейсов: {selectedCount}
          </span>
        )}
      </div>
      <div className="text-sm text-muted-foreground">
        Показано {displayedCount} из {totalCount}
      </div>
    </div>
  );
}
